export default "__VITE_ASSET__nzn5YhbV__"